bootstrapApp.$inject = ['$transitions'];

export function bootstrapApp($transitions) {
  $transitions.onStart({ to: '**' }, async (trans) => {
    const auth = trans.injector().get('AuthService');

    if (
      trans.to().name !== 'login' &&
      trans.to().name !== 'app.activityReport'
    ) {
      const isAuthenticated = await auth.isAuthenticated();
      if (!isAuthenticated) {
        // User isn't authenticated. Redirect to a new Target State
        return trans.router.stateService.target('login');
      }
    }
  });
}
